import ExcelIcon from '@account-root/account-react/src/assets/icons/excel-white.svg';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import { InputUpload } from '@ifca-root/react-component/src/components/Input/InputUpload';
import SnackBarMsg from '@ifca-root/react-component/src/components/SnackBar/SnackBarMsg';
import IconText from '@ifca-root/react-component/src/components/Typography/IconText';
import { Button, List, ListItem, ListItemText } from '@material-ui/core';
import React from 'react';
import { useForm } from 'react-hook-form';
import { ItemExcelForm } from './ItemExcelFn';
import { BillItemExcelForm } from './BillItemExcelFn';

interface ISnackBarProps {
  openSnackBar: boolean;
  snackBarMessage: string;
  setOpenSnackBar?: React.Dispatch<boolean>;
  onClickButton?: any;
  label?: string;
}
interface IItemExcelInputProps {
  openUpload: boolean;
  setOpenUpload: any;
  upload: string;
  template: any;
  onDownloadTemplate: any;
  onSelectFile: any;
  setUpload: any;
  setTemplate: any;
  onUploadTemplate: any;
  snackBarProps: ISnackBarProps;
  showDupErrors?: boolean;
  duplicateItems?: any;
  errorDia?: boolean;
  setErrorDia?: React.Dispatch<boolean>;
  resetFileUpload?: any;
  showFooter?: boolean;
  reUpload?: boolean;
  isBillItem?: boolean;
}

export interface ItemImportExcelProps {
  ItemImportExcelID: String;
}

export const ItemExcelInput = (props: IItemExcelInputProps) => {
  const {
    openUpload,
    setOpenUpload,
    upload,
    onDownloadTemplate,
    onSelectFile,
    setUpload,
    setTemplate,
    onUploadTemplate,
    snackBarProps,
    duplicateItems,
    showDupErrors,
    errorDia,
    setErrorDia,
    resetFileUpload,
    showFooter = true,
    reUpload = false,
    isBillItem = false,
  } = props;

  const {
    openSnackBar,
    snackBarMessage,
    setOpenSnackBar,
    onClickButton,
    label,
  } = snackBarProps;

  const {
    handleSubmit,
    control,
    register,
    watch,
    setError,
    clearErrors,
    errors,
  } = useForm<ItemImportExcelProps>();

  return (
    <div>
      {showDupErrors && errorDialog(errorDia, setErrorDia, duplicateItems)}
      <CommonDialog
        fullWidth={true}
        open={openUpload}
        onClose={() => {
          resetFileUpload();
          setUpload('');
          setTemplate([]);
          setOpenUpload(false);
        }}
        sections={{
          header: {
            title: isBillItem ? 'Bill Item Upload' : 'Item Upload',
          },
          body: () => (
            <>
              <InputUpload
                accept={'.xlsx, .xls, .cxv'}
                value={upload}
                label="File"
                required
                multiline={true}
                handleUpload={e => onSelectFile(e)}
                className="p-b-20"
              />
            </>
          ),
          leftFooterIcon: (
            <span style={{ width: '100%' }}>
              <Button
                variant="contained"
                size="small"
                className="btn-dialog btn-primary"
                onClick={() => {
                  if (isBillItem) {
                    onDownloadTemplate({
                      name: `Bill Item Upload Excel SpreadSheet`,
                      workSheetName: `Bill Item Upload Excel List`,
                      headerSetup: BillItemExcelForm,
                      isHeaderLocked: true,
                      defaultHeaderFillStyle: {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'D3D3D3' },
                      },
                      defaultHeaderBorderStyle: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                      },
                      listType: {
                        hasCountry: true,
                        hasNationality: true,
                      },
                    });
                  } else {
                    onDownloadTemplate({
                      name: `Item Upload Excel SpreadSheet`,
                      workSheetName: `Item Upload Excel List`,
                      headerSetup: ItemExcelForm,
                      isHeaderLocked: true,
                      defaultHeaderFillStyle: {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'D3D3D3' },
                      },
                      defaultHeaderBorderStyle: {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                      },
                      listType: {
                        hasCountry: true,
                        hasNationality: true,
                      },
                    });
                  }
                }}
                style={{
                  float: 'left',
                }}
                color="primary"
              >
                <IconText
                  icon={
                    <img
                      src={ExcelIcon}
                      style={{ width: '19px', paddingRight: '5px' }}
                    />
                  }
                  font="mdDesc"
                  children={'Download'}
                />
              </Button>
            </span>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => [
                    setOpenUpload(false),
                    setUpload(''),
                    setTemplate([]),
                    resetFileUpload(),
                  ],
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    onUploadTemplate();
                  },
                  variant: 'contained',
                  color: 'primary',
                  disabled: !upload,
                },
              },
            ],
          },
        }}
      />

      <SnackBarMsg
        open={openSnackBar}
        message={snackBarMessage}
        setOpen={setOpenSnackBar}
        label={label}
        onClickButton={onClickButton}
      />
    </div>
  );
};

const errorDialog = (
  openErrDialog: boolean,
  setOpenErrDia: React.Dispatch<boolean>,
  duplicateItems: string[],
) => (
  <CommonDialog
    fullWidth={true}
    open={openErrDialog}
    onClose={() => {
      setOpenErrDia(false);
    }}
    sections={{
      header: { title: 'Item(s) exists' },
      body: () => (
        <>
          <div>
            <span className="mdDesc text-noflow">
              Unable to upload the following item(s).
              <List>
                {duplicateItems?.map((v, i) => (
                  <ListItem key={i}>
                    <ListItemText
                      style={{ height: '10px' }}
                      primary={
                        <span className="mdDesc flex-space">{`- ${v}`}</span>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </span>
            <span className="desc text-noflow">
              Please remove duplicated items and try again.
            </span>
          </div>
        </>
      ),
      footer: {
        actions: [
          {
            displayText: 'Close',
            props: {
              onClick: () => {
                setOpenErrDia(false);
              },
              variant: 'contained',
              color: 'primary',
            },
          },
        ],
      },
    }}
  />
);
